export default {"src":"/_next/static/media/logo.41c719f0.svg","height":60,"width":260};